/**
 * Fallback expense categories used when database table is not available
 * These will be replaced by DB categories when useExpenseCategories() returns data
 */
export const FALLBACK_CATEGORIES = [
  { value: 'Refueling', label: 'Refueling', icon_path: '/icons/ExpenseIcons/Refueling.png' },
  { value: 'Insurance', label: 'Insurance', icon_path: '/icons/ExpenseIcons/Insurance.png' },
  { value: 'Maintenance', label: 'Maintenance', icon_path: '/icons/ExpenseIcons/Maintenance.png' },
  { value: 'Repairs', label: 'Repairs', icon_path: '/icons/ExpenseIcons/Repairs.png' },
  { value: 'Parts', label: 'Parts', icon_path: '/icons/ExpenseIcons/Parts.png' },
  { value: 'Tires', label: 'Tires', icon_path: '/icons/ExpenseIcons/Tires.png' },
  { value: 'Parking', label: 'Parking', icon_path: '/icons/ExpenseIcons/Parking.png' },
  { value: 'Car Wash', label: 'Car Wash', icon_path: '/icons/ExpenseIcons/CarWash.png' },
  { value: 'Fine', label: 'Fine', icon_path: '/icons/ExpenseIcons/Fine.png' },
  { value: 'Tax', label: 'Tax', icon_path: '/icons/ExpenseIcons/Tax.png' },
  { value: 'Wiper Blades', label: 'Wiper Blades', icon_path: '/icons/ExpenseIcons/WiperBlades.png' },
  { value: 'Tuning', label: 'Tuning', icon_path: '/icons/ExpenseIcons/Tuning.png' },
  { value: 'Accessories', label: 'Accessories', icon_path: '/icons/ExpenseIcons/Accessories.png' },
  { value: 'Financing', label: 'Financing', icon_path: '/icons/ExpenseIcons/Financing.png' },
  { value: 'Car Inspection', label: 'Car Inspection', icon_path: '/icons/ExpenseIcons/CarInspection.png' },
  { value: 'Other', label: 'Other', icon_path: null },
];


